<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<el-form ref="form" :model="form" label-position="left" label-width="100px">
				<el-form-item label="提成名称：" style="margin-bottom:10px">
					<el-input class="input" v-model="form.commission_name" placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="触发执行：" style="margin-bottom:5px">
					<el-checkbox-group v-model="form.commission_trigger">
						<el-checkbox v-for="item in triggerList" :label="item.lable"
							name="type">{{item.value}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="适用岗位：">
					<el-select class="select" v-model="form.commission_role" clearable placeholder="角色列表">
						<el-option v-for="item in roleList" :key="item.group_id" :label="item.group_name"
							:value="item.group_id" />
					</el-select>
				</el-form-item>
				<el-form-item label="提成方案：" style="margin-bottom:0">
					<div class="add_div" v-for="(item,index) in form.commission_plans">
						<div class="item_div">
							<span>{{index+1}}、当收款金额在</span>
							<el-input class="input_add" v-model="item.min" placeholder="请输入内容" />
							<span>到</span>
							<el-input class="input_add" v-model="item.max" placeholder="请输入内容" />
							<span>时，提成比例为</span>
							<el-input class="input_add" v-model="item.percent" placeholder="请输入内容"></el-input>
							<span>%</span>
							<el-button type="primary" plain style="margin-left: 80px" @click="addItem(index+1)">添加</el-button>
							<el-button v-if="index > 0" type="danger" plain @click="deleteItem(index)">删除</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="有效期限：">
					<el-date-picker class="picker" v-model="timeArr" type="datetimerange"
						value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间"
						end-placeholder="结束时间" placeholder="请选择时间范围" />
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm()">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import {
		commission,
		roleLists
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				tip: '客户走访过程记录。',
				triggerList: [{
					lable: '1',
					value: '财务—业务收款—关联合同'
				}],
				roleList: [], //角色列表
				timeArr: [], //时间范围
				form: {
					commission_name: '', //名称
					commission_trigger: [], //触发
					commission_role: '', //角色
					start_time: '', //开始时间
					end_time: '', //结束时间
					commission_plans: [{ //提成方案
						min: '', //最少收款
						max: '', //最高收款
						percent: '' //提成比例
					}]
				},
				page: 1, //当前页 刷新后默认显示第一页
				limit: 10, //每一页显示的数据量 此处每页显示10条数据
				total: 0, //总条数
			}
		},
		mounted() {
			if (this.type != -1) {
				//编辑
				this.form.commission_id = this.type;
				this.getCommissionDetail();
			}
			this.getRoleList();
		},
		methods: {

			//获取提成方案详情
			getCommissionDetail() {
				commission({
					commission_id: this.form.commission_id
				}, 3).then(res => {
					if (res.code == 0) {
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
						this.form.commission_trigger = [res.data.commission_trigger]
						this.timeArr = [res.data.start_time,res.data.end_time];
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			//获取角色列表
			getRoleList() {
				roleLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count;
						this.roleList = res.data;
					}
				}).catch(err => {})
			},
			
			//添加提成方案条目
			addItem(index) {
				this.form.commission_plans.splice(index, 0, {})
			},
			
			//移除提成方案条目
			deleteItem(index) {
				this.form.commission_plans.splice(index, 1)
			},

			//提交表单
			submitForm() {
				var type = this.type != -1 ? 2 : 0;
				this.form.start_time = this.timeArr[0];
				this.form.end_time = this.timeArr[1];
				commission({
					...this.form
				}, type).then(res => {
					if (res.code == 0) {
						this.$message.success(res.msg);
						this.$emit('close', 0)
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			close() {
				this.$emit('close')
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
		padding: 20px 20px 0 20px;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 644px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
	}

	.add_div {
		display: flex;
		flex-direction: column;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		margin-bottom: 22px;
	}

	.input_add {
		width: 120px;
		margin: 0 10px;
	}

	.select {
		width: 137px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>